// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"d588e96e","160":"c2aae9b3","266":"d588e96e","540":"d588e96e","623":"96626acd","639":"d588e96e"}[chunkId] + ".css";
};